import type { TFunction } from 'i18next';

import { isFreeSpinsBundleItem } from '../../../stores/rewards/helpers';
import type { StampRewardPackage } from '../../../stores/stamp-card/types';
import { formatValueWithK } from '../../../utils/helpers';

export type PrizeType = 'FREE_SPINS' | 'SC' | 'CC';

export interface PrizeLine {
  prizeType: PrizeType;
  coinsAmount: string;
  rawAmount?: number;
  imageUrl?: string;
}

const toPositiveAmount = (value: number | string | null | undefined): number | null => {
  const amount = Number(value ?? 0);

  return Number.isFinite(amount) && amount > 0 ? amount : null;
};

export const toPrizeLines = (rewardPackage: StampRewardPackage | null | undefined, t: TFunction): PrizeLine[] => {
  if (!rewardPackage) return [];

  const lines: PrizeLine[] = [];

  const scAmount = toPositiveAmount(rewardPackage.scCoin);
  if (scAmount) lines.push({ prizeType: 'SC', coinsAmount: formatValueWithK(scAmount, t), rawAmount: scAmount });

  const gcAmount = toPositiveAmount(rewardPackage.gcCoin);
  if (gcAmount) lines.push({ prizeType: 'CC', coinsAmount: formatValueWithK(gcAmount, t), rawAmount: gcAmount });

  const freeSpinsItem = (rewardPackage.bundleItems ?? []).find(isFreeSpinsBundleItem);
  if (freeSpinsItem) {
    const imageUrl =
      freeSpinsItem.widgetImageUrl ??
      freeSpinsItem.bundlePayload?.gameImageUrl ??
      freeSpinsItem.bundlePayload?.imageUrl;
    lines.push({ prizeType: 'FREE_SPINS', coinsAmount: '', imageUrl });
  }

  return lines;
};
